import { ENVIRONMENT } from 'config/settings';

export const debugLog = (...args) => {
  if (ENVIRONMENT === 'dev' || ENVIRONMENT === 'qa') {
    console.log(...args);
  }
};
